export const ru = {
    'regions-transform-error-for-none-groups': 'Не выбрано ни одной группы для изменения регионов показа',
    'regions-transform-full-error-many': 'Не удалось применить изменения регионов показа к выбранным группам',
    'regions-transform-full-error-one': 'Не удалось применить изменения регионов показа к выбранной группе',
    'regions-transform-full-success-many': 'Изменения регионов показа применены к выбранным группам',
    'regions-transform-full-success-one': 'Изменения регионов показа применены к выбранной группе',
    'regions-transform-hint-count-campaigns': {
        one: 'Выбрана {count} кампания. Изменения будут применены ко всем группам этой кампании',
        some: 'Выбрана {count} кампании. Изменения будут применены ко всем группам этих кампаний',
        many: 'Выбрана {count} кампаний. Изменения будут применены ко всем группам этих кампаний',
        none: 'Выбрана {count} кампаний.'
    },
    'regions-transform-partial-success': {
        one: 'Изменения регионов показа применены к {count} группе из {total}',
        some: 'Изменения регионов показа применены к {count} группам из {total}',
        many: 'Изменения регионов показа применены к {count} группам из {total}',
        none: 'Изменения регионов показа применены к {count} группам из {total}'
    },
    'regions-transform-partial-success-with-link': {
        one: 'Изменения регионов показа применены к {count} группе из {total}. В остальных не удалось',
        some: 'Изменения регионов показа применены к {count} группам из {total}. В остальных не удалось',
        many: 'Изменения регионов показа применены к {count} группам из {total}. В остальных не удалось',
        none: 'Изменения регионов показа применены к {count} группам из {total}. В остальных не удалось'
    }
};
